var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.7903,
    cy: 7.99984,
    rx: 6.66667,
    ry: 6.66667,
    transform: "rotate(60 8.7903 7.99984)",
    fill: "#EB5757",
    stroke: "#EB5757",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0898 4.85938C12.0898 4.85938 11.6774 5.27186 9.02571 7.92351C6.37406 10.5752 5.49017 11.459 5.49017 11.459",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49023 4.85938C5.49023 4.85938 5.90272 5.27186 8.55437 7.92351C11.206 10.5752 12.0899 11.459 12.0899 11.459",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5d90de445918d09ccab6347e8f4f8c25.svg";
export { ForwardRef as ReactComponent };